module.exports = __webpack_public_path__ + "static/media/dad gif 2.ac450020.gif";